/*
 * Copyright (c) 2021 OTB Africa. All rights reserved. <https://otbafrica.com>
 *
 * Created Date: Monday, November 22nd 2021, 7:23:47 pm
 * Author: OTB Africa, developers@otbafrica.com
 *
 * Use of this source code is governed by the license that can be found in
 * the LICENSE file or at https://developers.otbafrica.com/licenses/
 */

import { APIMany2OneSelectFormInput, ConcreteAPIMany2OneSelectFormInputProps } from "ui-widgets";
import { Country } from "lib/schemas";
import { APISERVICEPATHS } from "lib/api";
import FlagIcon from "@mui/icons-material/Flag";

export const CountryPickerInput = <T,>(props: ConcreteAPIMany2OneSelectFormInputProps<T, Country>) => {
  return (
    <APIMany2OneSelectFormInput<T, Country>
      label="Country"
      itemIdProperty="id"
      getOptionLabel={(option) => option.countryname}
      loadingText="Loading Countries"
      apiServicePath={APISERVICEPATHS.countries}
      inputStartAdornment={<FlagIcon color="primary" />}
      {...props}
    />
  );
};
